import { render, staticRenderFns } from "./PermissionListTab.vue?vue&type=template&id=5e73c542&"
import script from "./PermissionListTab.vue?vue&type=script&lang=js&"
export * from "./PermissionListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports